export default {
  icon: 'mdi-cash-minus',
  text: 'Contas a pagar',
  permissions: [
    { name: 'billPayableIndex', text: 'Visualizar contas a pagar', value: 0 },
    { name: 'billPayableCreateEdit', text: 'Cadastrar/Editar contas a pagar', value: 0 },
    { name: 'billPayableCancel ', text: 'Cancelar contas a pagar', value: 0 },
    { name: 'payBillPayable', text: 'Pagar contas', value: 0 },
  ]
}